module.exports = __webpack_public_path__ + "static/media/go_to_report_btn.9934c311.svg";